export default "__VITE_ASSET__CQqHhXyd__"